import React from "react";
import { fetcher } from "@action.sustainability/storybook-dashboard/utils/fetching";

export const postFetch = async (url, data, method = "POST") => {
  const response = await fetcher(url, method, data);
  return response.payload;
};

export function Hide({ when, children, showInstead = null }) {
  return when ? showInstead : children;
}

export function FormGroup({
  id,
  placeholder = null,
  type = "text",
  label = null,
  helpText = null,
}) {
  return (
    <div className="form-group">
      <Hide when={!label}>
        <label htmlFor={id}>{}</label>
      </Hide>
      <input
        type={type}
        className="form-control"
        id={id}
        name={id}
        placeholder={placeholder}
      />
      <Hide when={!helpText}>
        <small id={`${id}Help`} className="form-text text-muted">
          {helpText}
        </small>
      </Hide>
    </div>
  );
}
